import request from '../utils/request';
import firebase from '../utils/firebase';

const version = '1.5.0';

const apiRequest = ({method = 'get', url, data, params, source = {}}) => {
  const {currentUser: user} = firebase.auth();
  return user
    .getIdToken()
    .then(idToken =>
      request({
        method,
        url: `/v3${url}`,
        data,
        params,
        headers: {
          token: idToken,
          version,
          'Content-Type': 'application/json',
        },
        cancelToken: source.token,
      }),
    )
    .then(response => response.data);
};

export const getFollowingStrategiesRequest = source =>
  apiRequest({
    url: '/strategies',
    source,
  });

export const getPicksRequest = source =>
  apiRequest({
    url: '/picks',
    source,
  });

export const getPaymentLinkRequest = (source, strategyId) =>
  apiRequest({
    url: `/strategies/${strategyId}/payment-link`,
    source,
  });

export const getFavoritePicksRequest = source =>
  apiRequest({
    url: '/favorites?status=pending',
    source,
  });

export const addFavoritePickRequest = (data, source) =>
  apiRequest({
    method: 'post',
    url: '/favorites',
    data,
    source,
  });

export const removeFavoritePickRequest = (id, source) =>
  apiRequest({
    method: 'delete',
    url: `/favorites/${id}`,
    source,
  });

export const unfollowStrategyRequest = (id, source) =>
  apiRequest({
    method: 'delete',
    url: `/strategies/${id}`,
    source,
  });

export const getStrategyResultsRequest = (strategyId, source) =>
  apiRequest({
    url: `/strategies/${strategyId}/results`,
    source,
  });

export const getStrategySettledPicksRequest = (strategyId, source) =>
  apiRequest({
    url: `/strategies/${strategyId}/settled`,
    source,
  });

export const followStrategyRequest = (id, source) =>
  apiRequest({
    method: 'post',
    url: `/strategies/${id}/follow`,
    source,
  });

export const getUserPaymentsRequest = source =>
  apiRequest({
    url: '/account/payments',
    source,
  });
